<!-- <mat-spinner *ngIf="loading"></mat-spinner> -->
<ng-container>
    <ng-progress [thick]="true" triggers="hover" container="body" ngbtooltip="Progress bar"></ng-progress>
    <app-header></app-header>
    <app-breadcrumb></app-breadcrumb>
    <router-outlet></router-outlet>
</ng-container>
<div class="envCorner" *ngIf="configService.config.envType">{{configService.config.envType}}</div>